/* eslint-disable camelcase */
import { CONSENT_COOKIE_NAME } from '../cookies/config'

export const appConfig = {
  cookieName: CONSENT_COOKIE_NAME,
  platform: 'consumerhelpweb',
  producer: 'help-experience-l-je',
  packageVersion: process.env.PACKAGE_VERSION,
  userCookieName: process.env.VUE_APP_JE_AUSER_COOKIE || 'je-auser'
}

export const trackingPageName = {
  article: 'helpArticle',
  PageNotFound: 'helpError',
  help: 'helpHome',
  'other-questions': 'helpOtherQuestions',
  SigninOidc: 'helpSignin',
  section: 'helpSection',
  reportConcern: 'helpReportContentConcern',
  default: 'helpUnknown'
}

export const schemaMap = {
  article_select: 'iglu:jet.care.helpcentre/article_select/jsonschema/1-0-0',
  callCS_select: 'iglu:jet.care.helpcentre/callCS_select/jsonschema/1-0-0',
  chat_select: 'iglu:jet.care.helpcentre/chat_select/jsonschema/1-0-0',
  contactForm_select: 'iglu:jet.care.helpcentre/contactForm_select/jsonschema/1-0-0',
  contactForm_success: 'iglu:jet.care.helpcentre/contactForm_success/jsonschema/1-0-0',
  contactForm_submit: 'iglu:jet.care.helpcentre/contactForm_submit/jsonschema/1-0-0',
  cx_article: 'iglu:jet.care.helpcentre/cx_article/jsonschema/1-0-0',
  cx_component: 'iglu:jet/cx_component/jsonschema/1-0-0',
  cx_consent: 'iglu:jet/cx_consent/jsonschema/1-1-0',
  cx_contactReason: 'iglu:jet.care.helpcentre/cx_contactReason/jsonschema/1-0-0',
  cx_csat: 'iglu:jet.care.helpcentre/cx_csat/jsonschema/1-0-0',
  cx_error: 'iglu:jet/cx_error/jsonschema/1-0-0',
  cx_feature: 'iglu:jet.care.helpcentre/cx_feature/jsonschema/1-0-0',
  cx_navigation: 'iglu:jet.care.helpcentre/cx_navigation/jsonschema/1-0-0',
  cx_order: 'iglu:jet.cust/cx_order/jsonschema/1-0-3',
  cx_page: 'iglu:jet/cx_page/jsonschema/1-0-0', // Req. -> "name<String>", "id<UUID>"
  cx_partner: 'iglu:jet.cust/cx_partner/jsonschema/1-0-0',
  cx_platform: 'iglu:jet/cx_platform/jsonschema/1-1-0', //  Req. -> "language<String>"",  "country<String>",  "version<String>"
  cx_producer: 'iglu:jet/cx_producer/jsonschema/1-0-1', // Req. -> "team<String"
  cx_review: 'iglu:jet.care.helpcentre/cx_review/jsonschema/1-0-0',
  cx_user: 'iglu:jet/cx_user/jsonschema/1-0-0', // Req. -> "anonymousId<String>"
  navigation_select: 'iglu:jet/navigation_select/jsonschema/1-0-0',
  section_select: 'iglu:jet.care.helpcentre/section_select/jsonschema/1-0-0',
  otherQuestions_select: 'iglu:jet.care.helpcentre/otherQuestions_select/jsonschema/1-0-0',
  search_clear: 'iglu:jet/search_clear/jsonschema/1-0-0',
  search_select: 'iglu:jet/search_select/jsonschema/1-0-0',
  search_success: 'iglu:jet/search_success/jsonschema/1-0-0'
}

/**
 * https://pages.github.je-labs.com/analytics-platform/snowplow-documentation/docs/new-integrations/global-contexts#jet-requirement
 */
export const globalContext = [
  {
    name: 'cx_consent',
    data: {
      status: []
    },
    schema: schemaMap.cx_consent
  },
  {
    name: 'cx_page',
    data: {
      id: '',
      name: ''
    },
    schema: schemaMap.cx_page
  },
  {
    name: 'cx_platform',
    data: {
      country: '',
      language: '',
      version: appConfig.packageVersion
    },
    schema: schemaMap.cx_platform
  },
  {
    name: 'cx_producer',
    data: {
      team: appConfig.producer
    },
    schema: schemaMap.cx_producer
  },
  {
    name: 'cx_user',
    data: {
      anonymousId: '' // Required
    },
    schema: schemaMap.cx_user
  }
]
